<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="auto"
      :loading="loading"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      {{opType | optionText(OpEnum.typeOption)}}仓库
      <span v-if="opType === OpEnum.type.UPDATE" class="modal-secondary-title">{{warehouse.name}}</span>
    </template>
    <template #content>
      <div v-if="false">
        <gj-input v-model="labelWidth" />
        <gj-input v-model="inputWidth" />
        <gj-input v-model="longInputWidth" />
      </div>
      <el-form
          ref="form"
          :model="form"
          :label-width="labelWidth">
        <el-row>
          <el-col :span="8">
            <el-form-item
                label="仓库名称"
                prop="name"
                :rules="[
                  $gjRequired('请输入仓库名称'),
                  $gjReRule(/^[\u4e00-\u9fa50-9a-zA-Z_]+$/, '仓库名称不符合规范!')
                ]">
              <gj-input
                  v-model="form.name"
                  :width="inputWidth"
                  placeholder="由中文字母数字下划线组成"
              ></gj-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                label="国家"
                prop="countryCode"
                :rules="[
                  $gjRequired('请选择国家'),
                ]">
              <gj-select
                  v-model="form.countryCode"
                  :width="inputWidth"
                  :options="option.country"
                  placeholder="请选择国家"
              ></gj-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                label="状态"
                prop="state"
                :rules="[
                  { required: true, message: '请选择状态', trigger: ['change'] },
                ]">
              <gj-select
                  v-model="form.state"
                  :width="inputWidth"
                  :options="WarehouseEum.stateOption"
                  :clearable="false"
                  placeholder="请选择状态"
              ></gj-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
                label="负责人"
                prop="contact">
              <gj-input
                  v-model="form.contact"
                  :width="inputWidth"
                  placeholder="请输入负责人"
              ></gj-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                label="联系电话"
                prop="telephone"
                :rules="[
                  $gjReRule(RE.phone, '请输入正确的手机号码', true, ['blur'])
                ]">
              <gj-input
                  v-model="form.telephone"
                  :width="inputWidth"
                  placeholder="请输入联系电话"
              ></gj-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
            label="联系地址"
            prop="address">
          <gj-input
              v-model="form.address"
              :width="longInputWidth">
          </gj-input>
        </el-form-item>
        <el-form-item
            label="备注"
            prop="memo"
            style="margin-bottom: 0;">
          <gj-textarea
              v-model="form.memo"
              :rows="4"
              :styles="{width: longInputWidth}">
          </gj-textarea>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, formRuleMixin, responseMixin, opTypeMixin, userGuideMixin} from "../../../../../../minxins";
  import {addWarehouseInfo, getWarehouseInfo, updateWarehouseInfo} from "../../../../../../api/warehouse";
  import {OpEnum} from "../../../../../../utils/options";
  import {WarehouseEum} from "../../../enum";

  export default {
    name: "app-op-warehouse-modal",
    mixins: [modalMixIn, formRuleMixin, responseMixin, opTypeMixin, userGuideMixin],
    props: {
      warehouse: {
        default: null
      },
      opType: {
        required: true
      }
    },
    data() {
      return {
        confirmLoading: false,
        form: {
          id: null,
          name: null,
          countryCode: null,
          state: null,
          contact: null,
          telephone: null,
          address: null,
          memo: null
         },
        labelWidth: '74px',
        inputWidth: '100%',
        longInputWidth: '800px',
        OpEnum: OpEnum,
        option: {
          country: WarehouseEum.countryOption,
        },
        WarehouseEum: WarehouseEum,
        loading: false
      }
    },
    created() {
      if (this.addOpType) {
        this.form.state = WarehouseEum.state.Active;
      } else if (this.editOpType) {
        this.loading = true;
        getWarehouseInfo(this.warehouse.id)
          .then(data => {
            Object.assign(this.form, data);
          })
          .complete(() => this.loading = false);
      }
    },
    methods: {
      confirm() {
        if (this.$gjFormValidate()) {
          this.confirmLoading = true;
          if (this.addOpType) {
            addWarehouseInfo(this.form)
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  this.$emit('created');
                  this.$emit('userGuide');
                  this.$gjDestroy();
                });
              })
              .complete(() => this.confirmLoading = false);
          } else if (this.editOpType) {
            updateWarehouseInfo(this.form)
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  this.$emit('updated');
                  this.$gjDestroy();
                });
              })
              .complete(() => this.confirmLoading = false);
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
</style>
